import { render, staticRenderFns } from "./UnifiedOfferStatusCell.vue?vue&type=template&id=280e6162&"
import script from "./UnifiedOfferStatusCell.vue?vue&type=script&lang=js&"
export * from "./UnifiedOfferStatusCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports